





















































































import {Component, Vue, Watch} from "vue-property-decorator";
import _ from "lodash";
import {Route} from "vue-router";
import {Action, Getter} from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";
import {permissions, ptfFeatures} from "@/Constants";
import {PowerBiReport} from "@/modules/PowerBi";
import {SocleFilters} from "@/modules/SocleFilters";
import {RequestFilters} from "@/modules/request/RequestFilters";

interface MenuItem {
    route?: {
        name: string;
        query?: Record<string, any>;
    };
    text: string;
    icon?: string;
    index?: string;
    children: MenuItem[];
    style?: string;
    class?: string;
    enabled?: boolean;
    module?: string;
}

@Component
export default class NavigationMenu extends Vue {
    private static readonly ZOOM_THRESHOLD = 120;
    @Action("resetSocleFilters") public resetSocleFilters!: (filters: SocleFilters | null) => void;
    @Action("resetRequestFilters") public resetRequestFilters!: (filters: RequestFilters | null) => void;
    @Getter("getCurrentOwner") public currentOwner!: Owner;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getSocleModuleName") public socleModuleName!: string;
    @Getter("isDsi") public isDsi!: boolean;
    @Getter("getCurrentUser") public currentUser!: any;
    @Getter("getOwnerReports") public ownerReports!: PowerBiReport[];
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string|null;
    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("hasPermission") public hasPermission!: (permissionName: string) => boolean;
    protected iconsOnly: boolean = NavigationMenu.ZOOM_THRESHOLD <= Math.round(window.devicePixelRatio * 100);

    private mounted() {
        this.addEventListenerOnResize();
        this.calcHeaderOverflow();
    }

    private beforeDestroy(): void {
        window.removeEventListener("resize", this.onResize);
    }

    @Watch("currentOwnerUuid")
    private refreshFilters(): void {
        this.resetSocleFilters(null);
        this.resetRequestFilters(null);
    }

    private get menu(): MenuItem[] {
        let menu: MenuItem[] = [];
        const adminMenu: MenuItem = {
            index: "adminMenu",
            text: "menuAdmin",
            icon: "cogs",
            children: [],
            style: "float:right",
        };

        const reportsByModule: Record<string, PowerBiReport[]> = {};

        if (Array.isArray(this.ownerReports)) {
            this.ownerReports.forEach((report) => {
                const hideModuleReport = _.some(this.currentUser.userHideFeatures, (line) => {
                    return line.code === "HIDE_" + report.module;
                });
                if (hideModuleReport) {
                    return;
                }
                if (!reportsByModule[report.module]) {
                    reportsByModule[report.module] = [];
                }
                reportsByModule[report.module].push(report);
            });
        }

        if (this.showHomepageFeature) {
            // Homepage module
            menu.push({
                route: {
                    name: "home",
                },
                text: "menuHomePage",
                icon: "home",
                children: [],
            });
        }

        if (this.showRequestFeature || this.showBillingFeature) {
            // Campaign module
            const campaignMenu: MenuItem = {
                index: "campaignsMenu",
                text: "campaignsMenu",
                icon: "bullhorn",
                children: [],
            };
            if (this.showRequestFeature) {
                campaignMenu.children.push({
                    route: {
                        name: "requests_list",
                    },
                    text: "menuRequestList",
                    icon: "briefcase",
                    children: [],
                });
            }
            if (this.showBillingFeature) {
                campaignMenu.children.push({
                    route: {
                        name: "insertion_list",
                    },
                    text: "menuInvoiceList",
                    icon: "file-invoice",
                    children: [],
                });
            }

            if ("REQUEST" in reportsByModule) {
                campaignMenu.children.push(this.generateReportMenu(reportsByModule.REQUEST, "request"));
            }

            if (this.showAdminFeature && this.showRequestFeature) {
                campaignMenu.children.push({
                    index: "requestAdminMenu",
                    text: "configuration",
                    icon: "cogs",
                    style: "float:right",
                    children: [
                        {
                            route: {
                                name: "admin_request_title_list",
                            },
                            text: "menuAdminRequestTitle",
                            children: [],
                        }
                    ],
                });
                if (this.hasFeature(ptfFeatures.topic) || this.isDsi) {
                    campaignMenu.children.forEach((menuData) => {
                        if (menuData.index === "requestAdminMenu") {
                            menuData.children.push({
                                route: {
                                    name: "admin_topic_list",
                                },
                                text: "menuAdminTopic",
                                children: [],
                            });
                        }
                    });
                }
            }
            menu.push(campaignMenu);
        }

        if (this.showZeroWasteFeature) {
            // ZeroWaste module
            const zeroWasteMenu: MenuItem = {
                index: "zgMenu",
                text: "menuSurpressionCompensation",
                icon: "balance-scale",
                children: [],
            };

            zeroWasteMenu.children.push(
                {
                    route: {
                        name: "surpression_compensation_list",
                    },
                    text: "menuCompensationValidation",
                    icon: "balance-scale",
                    children: [],
                }
            );

            // Add reports
            if ("REPORT_ZERO_WASTE" in reportsByModule) {
                zeroWasteMenu.children.push(this.generateReportMenu(reportsByModule.REPORT_ZERO_WASTE, "zero_waste"));
            }

            menu.push(zeroWasteMenu);
        }

        if (this.showCompetitorFeature) {
            const competitorMenu: MenuItem = {
                index: "competitorMenu",
                text: "competitor",
                icon: "weight-hanging",
                route: {
                    name: "competitor_list",
                },
                children: [],
            };

            menu.push(competitorMenu);
        }

        if (this.showSocleFeature) {
            // Socle module
            const socleMenu: MenuItem = {
                index: "socleMenu",
                text: this.socleModuleName,
                icon: "balance-scale",
                children: [],
            };

            if (this.showSocleValidationFeature) {
                socleMenu.children.push(
                    {
                        route: {
                            name: "socle_list",
                        },
                        text: this.socleModuleName,
                        icon: "balance-scale",
                        children: [],
                    }
                );
            }
            if (this.hasFeature("SOCLE_PARTICIPATION")) {
                socleMenu.children.push(
                    {
                        route: {
                            name: "socle_participation_list",
                        },
                        text: "participationMenu",
                        icon: "check",
                        children: [],
                    }
                );
            }

            // Add reports
            if ("SOCLE" in reportsByModule) {
                socleMenu.children.push(this.generateReportMenu(reportsByModule.SOCLE, "socle"));
            }
            menu.push(socleMenu);
        }

        if (1 === menu.length && menu[0].children) {
            if (menu[0].text === "menuHomePage") {
                menu[0].children.push({
                    route: {
                        name: "home",
                    },
                    text: "menuHomePage",
                    icon: "home",
                    children: [],
                });
            }
            menu = menu[0].children;
        }

        if (this.showReportFeature || this.userDepartment) {
            if ("REPORT" in reportsByModule) {
                menu.push(this.generateReportMenu(reportsByModule.REPORT));
            }
            if (!this.showZeroWasteFeature && this.showReportZeroWasteFeature) {
                if ("REPORT_ZERO_WASTE" in reportsByModule) {
                    menu.push(this.generateReportMenu(reportsByModule.REPORT_ZERO_WASTE));
                }
            }
        }

        if (this.userDepartment) {
            // General administration
            adminMenu.children.push(
                {
                    route: {
                        name: "admin_line_check",
                    },
                    text: "adminLineCheck",
                    class: "important-item",
                    children: [],
                },
                {
                    route: {
                        name: "admin_owner_attributes",
                    },
                    text: "adminOwnerManagerTitle",
                    class: "important-item",
                    children: [],
                }
            );
            if (this.showZeroWasteFeature) {
                adminMenu.children.push(
                    {
                        route: {
                            name: "admin_compensation_catalog_list",
                        },
                        text: "menuAdminZeroWasteCatalog",
                        class: "important-item",
                        children: [],
                    }
                );
            }
            if (this.isDsi) {
                adminMenu.children.push(
                    {
                        route: {
                            name: "admin_request_client_list",
                        },
                        text: "menuAdminRequestClient",
                        class: "critical-item",
                        children: [],
                    }
                );
            }
            menu.push(adminMenu);
        }

        this.calcHeaderOverflow();
        return menu;
    }

    private get showRequestFeature(): boolean {
        return this.hasFeature(ptfFeatures.request) && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_REQUEST";
        });
    }

    private get showBillingFeature(): boolean {
        return this.hasFeature(ptfFeatures.billing) && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_BILLING";
        });
    }

    private get showZeroWasteFeature(): boolean {
        return this.hasFeature(ptfFeatures.zero_waste) && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_ZERO_WASTE";
        });
    }

    private get showReportZeroWasteFeature(): boolean {
        return !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_REPORT_ZERO_WASTE";
        });
    }

    private get showCompetitorFeature(): boolean {
        return this.hasFeature(ptfFeatures.competitor) && this.hasPermission(permissions.competitorAccess);
    }

    private get showSocleFeature(): boolean {
        return this.hasFeature(ptfFeatures.socle) && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_SOCLE";
        });
    }

    private get showSocleValidationFeature(): boolean {
        return this.hasFeature(ptfFeatures.socle) && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_SOCLE_VALIDATION";
        });
    }

    private get showHomepageFeature(): boolean {
        return this.hasFeature(ptfFeatures.homepage) && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_HOMEPAGE";
        });
    }

    private get showReportFeature(): boolean {
        return this.hasFeature(ptfFeatures.report) && !_.some(this.currentUser.userHideFeatures, (line) => {
            return line.code === "HIDE_REPORT";
        });
    }

    private get showAdminFeature(): boolean {
        return this.hasFeature(ptfFeatures.admin);
    }

    private onResize = () => {
        this.iconsOnly = NavigationMenu.ZOOM_THRESHOLD <= Math.round(window.devicePixelRatio * 100);
        this.calcHeaderOverflow();
    }

    private generateReportMenu(reports: PowerBiReport[], module: string = "global"): MenuItem {
        const reportMenu: MenuItem = {
            index: `reportMenu-${module}`,
            text: "reportMenu",
            icon: "chart-pie",
            children: [],
        };
        if (1 === reports.length) {
            if (reports[0].icon) {
                reportMenu.icon = reports[0].icon;
            }
            reportMenu.route = {
                name: "report",
                query: {id: _.get(reports[0], "uuid", null)},
            };
            reportMenu.text = _.get(reports[0], "label", reports[0].uuid);
            reportMenu.enabled = _.get(reports[0], "enabled", true);
        } else {
            reports.forEach((report) => {
                reportMenu.children.push({
                    route: {
                        name: "report",
                        query: {id: _.get(report, "uuid", null)},
                    },
                    text: _.get(
                        report,
                        "label",
                        report.uuid
                    ),
                    enabled: _.get(report, "enabled", true),
                    icon: "chart-pie",
                    children: [],
                });
            });
        }

        return reportMenu;
    }

    private getIndex(route: Route | { name: string; query?: Record<string, any> } | undefined): string {
        if (typeof route === "undefined") {
            return "";
        }
        const discriminant = _.get(route, "query.id", null);
        const routeName = _.get(route, "name", "");
        if (!discriminant) {
            return routeName;
        }

        return `${routeName}_${discriminant}`;
    }

    private get activeIndex(): string {
        if ("insertion_document_list" === this.getIndex(this.$route)) {
            return "insertion_list";
        }
        return this.getIndex(this.$route);
    }

    private getTooltipDisabled(enabled: boolean | undefined): string | null {
        return false === enabled ? _.invoke(this.$options.filters, "trans", "disabledMenuItemTooltip") : null;
    }

    private hasChildren(item: MenuItem) {
        return !!item.children && 0 < item.children.length;
    }

    private isDisabled(item: MenuItem) {
        if (item.enabled === undefined) {
            return false;
        }
        return !item.enabled;
    }

    private addEventListenerOnResize() {
        window.addEventListener("resize", () => {
            this.iconsOnly = NavigationMenu.ZOOM_THRESHOLD <= Math.round(window.devicePixelRatio * 100);
            this.calcHeaderOverflow();
        }, { passive: true });
    }
    private calcHeaderOverflow() {
        this.$nextTick(() => {
            if (!_.get(this.$refs, "navigationMenu", false)) {
                return;
            }
            const navigationMenu: Vue = this.$refs.navigationMenu as Vue;
            const totalWidth = navigationMenu.$el.clientWidth;
            let childrenWidth = 0;
            navigationMenu.$children.forEach((child: Vue) => {
                childrenWidth += child.$el.clientWidth;
            });
            if (childrenWidth > totalWidth) {
                this.iconsOnly = true;
            }
        });
    }
    private setTitle(text: string): string {
        if (!this.$options || !this.$options.filters || this.iconsOnly) {
            return "";
        }
        return this.$options.filters.trans(text);
    }
}
